/*
  Замечания к строкам реестра - свёрнутым блоком, одинаковые собраны вместе
  (05.10.2026, замечание владельца со снимком).

  До этого под таблицей шли двадцать три абзаца подряд: двенадцать про итоги и
  подписи под таблицей, пять одинаковых про вид собственности, и у двух строк
  по два замечания сразу. Владелец назвал это «портянкой» и попросил: свернуть,
  наверху только «Замечания к строкам файла: N», подробности по нажатию.

  Внутри - группа на вид замечания: вид и пояснение один раз, ниже строки с
  сутью каждой. Вид, суть и пояснение приходят с сервера раздельно - клиент
  текст замечания не сочиняет и не режет. Итоги и подписи под таблицей - не
  замечания, они названы одной строкой номерами (пункт 203 реестра).

  У строки названы и номер в файле, и лицевой счёт: владелец искал «строку 10»
  по графе «№» реестра, где 10 стоит у другого счёта, и решил, что система
  ошиблась на строке, где вид собственности «Частная».
*/

import { rows as rowsCount } from '../api/format.js'

function groups(issues) {
  const byReason = new Map()
  for (const issue of issues) {
    const group = byReason.get(issue.reason) ?? { ...issue, items: [] }
    group.items.push(issue)
    byReason.set(issue.reason, group)
  }
  return [...byReason.values()]
}

function where(issue) {
  const row = issue.sheet ? `«${issue.sheet}», строка ${issue.row_number}` : `Строка ${issue.row_number}`
  return issue.account_number ? `${row}, счёт ${issue.account_number}` : row
}

function bySheet(skipped) {
  const sheets = new Map()
  for (const item of skipped) {
    sheets.set(item.sheet, [...(sheets.get(item.sheet) ?? []), item.row_number])
  }
  return [...sheets.entries()]
    .map(([sheet, numbers]) => (sheet ? `«${sheet}» - ${numbers.join(', ')}` : numbers.join(', ')))
    .join('; ')
}

export default function RegistryIssues({ issues, skipped }) {
  if (!issues.length && !skipped.length) return null
  return (
    <details className="onec__summary registry-issues">
      <summary className="onec__skipped">
        {issues.length
          ? `Замечания к строкам файла: ${rowsCount(issues.length)}`
          : 'Замечаний к строкам файла нет'}
      </summary>
      {groups(issues).map((group) => (
        <section key={group.reason} className="registry-issues__group">
          <p className="registry-issues__title">
            {group.title} - {rowsCount(group.items.length)}
          </p>
          <p className="muted">{group.hint}</p>
          <ul className="registry-issues__rows">
            {group.items.map((issue) => (
              // Суть входит в ключ: у одной строки бывают две нечитаемые справочные суммы.
              <li key={`${issue.sheet}-${issue.row_number}-${issue.detail}`}>
                {where(issue)}: {issue.detail}
              </li>
            ))}
          </ul>
        </section>
      ))}
      {skipped.length ? (
        <p className="muted registry-issues__group">
          Не загружались строки без лицевого счёта и Ф.И.О. - итоги и подписи под таблицей (
          {rowsCount(skipped.length)}): {bySheet(skipped)}.
        </p>
      ) : null}
    </details>
  )
}
